import React, { useState, useRef } from 'react';
import './InternshipDetail.css';
import InternshipApply from '../InternshipApply/InternshipApply';
import ProfessionalInternship from '../ProfessionalInternship/ProfessionalInternship';

function InternshipDetail({ onClose }) {
  const [showDuration, setShowDuration] = useState(false);
  const durationRef = useRef(null);
  const [showApply, setShowApply] = useState(null);
  const [showProfessional, setShowProfessional] = useState(false);

  const handleTrainingDetails = () => {
    setShowDuration(true);
    setTimeout(() => {
      durationRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  return (
    <div className="id__overlay">
      <div className="id__box">

        <button className="id__close" onClick={onClose}>✕ Close</button>

        <h2 className="id__title">Internship Programmes at ibots</h2>
        <p className="id__subtitle">
          Choose a track below. Training internships offer skill development
          with certification; the Professional track offers project exposure
          with the iBots engineering team.
        </p>

        <div className="id__cards">

          {/* Card 1 — Training Internship */}
          <div className="id__card">
            <div className="id__card-top">
              <div>
                <p className="id__card-tag">TRAINING INTERNSHIP</p>
                <h3 className="id__card-title id__card-title--blue">Training Internship</h3>
              </div>
            </div>
            <p className="id__card-desc">
              A structured internship with guided, hands-on training in
              industry-relevant skills. Participants receive a certificate
              along with an internship experience letter.
            </p>
            <p className="id__card-note">↓ Three duration tracks available below</p>
            <button className="id__card-btn" onClick={handleTrainingDetails}>More Details →</button>
          </div>

          {/* Card 2 — Professional Internship */}
          <div className="id__card id__card--stipend">
            <div className="id__card-top">
              <div>
                <p className="id__card-tag">PROFESSIONAL INTERNSHIP</p>
                <h3 className="id__card-title">Professional Internship</h3>
              </div>
              <span className="id__card-badge id__card-badge--stipend">Stipend Provided</span>
            </div>
            <p className="id__card-desc">
              A selective internship where chosen candidates work with the
              iBots engineering team on live projects and product development.
              Interns gain real industry experience and receive a stipend during the program.
            </p>
            <div className="id__hire-box">
              <span className="id__hire-icon">⭐</span>
              <div>
                <p className="id__hire-title">INTERN-TO-HIRE PATHWAY AVAILABLE</p>
                <p className="id__hire-desc">
                  High-performing interns may be considered for a full-time role at ibots
                  upon successful completion of the internship. Selection is based entirely
                  on performance, contribution to projects, and team fit during the engagement.
                </p>
              </div>
            </div>
            <p className="id__card-note">↓ Hardware & Software domain details available below</p>
            <div className="id__contact">
              <span>📧 info@ibots.in</span>
              <span className="id__contact-dot">·</span>
              <span>📞 +91 9442717713</span>
            </div>
            <button className="id__card-btn" onClick={() => setShowProfessional(true)}>More Details →</button>
          </div>

        </div>

        {/* Duration Tracks */}
        <div ref={durationRef}>
          {showDuration && (
            <div className="id__duration">
              <h3 className="id__duration-title">Training Internship — Select Your Duration Track</h3>

              <div className="id__duration-cards">

                {/* 1 Week */}
                <div className="id__dur-card">
                  <div className="id__dur-header">
                    <div>
                      <h4 className="id__dur-weeks">1 Week</h4>
                      <p className="id__dur-track">Track A — Foundational</p>
                    </div>
                    <span className="id__dur-badge">Week 1 Batch</span>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '0 16px' }}>
                    <p style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', marginBottom: '6px' }}>Foundation Courses</p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                      {['Embedded Systems', 'IoT', 'Robotics'].map((c, i) => (
                        <span key={i} style={{ background: '#e8f5e9', color: '#2e7d32', borderRadius: '20px', padding: '3px 10px', fontSize: '11px', fontWeight: 600 }}>✓ {c}</span>
                      ))}
                    </div>
                  </div>
                  <p className="id__dur-desc">
                    An intensive beginner-level program focused on building core technical
                    understanding through hands-on learning. Students work on simple practical
                    modules and mini-projects to develop basic skills and confidence in hardware-based systems.
                  </p>
                  <button className="id__dur-btn" onClick={() => setShowApply('week1')}>View Details & Apply →</button>
                </div>

                {/* 2 Weeks */}
                <div className="id__dur-card">
                  <div className="id__dur-header">
                    <div>
                      <h4 className="id__dur-weeks">2 Weeks</h4>
                      <p className="id__dur-track">Track B — Foundation & Advanced</p>
                    </div>
                    <span className="id__dur-badge">Week 2 Batch</span>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '0 16px' }}>
                    <p style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', marginBottom: '6px' }}>Foundation Courses</p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
                      {['Embedded Systems', 'IoT', 'Robotics'].map((c, i) => (
                        <span key={i} style={{ background: '#e8f5e9', color: '#2e7d32', borderRadius: '20px', padding: '3px 10px', fontSize: '11px', fontWeight: 600 }}>✓ {c}</span>
                      ))}
                    </div>
                    <p style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', marginBottom: '6px' }}>Advanced Courses</p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                      {['AI with RPi', 'Mechatronics', 'Drone Technology', '3D Printing'].map((c, i) => (
                        <span key={i} style={{ background: '#e3f2fd', color: '#1565c0', borderRadius: '20px', padding: '3px 10px', fontSize: '11px', fontWeight: 600 }}>✓ {c}</span>
                      ))}
                    </div>
                  </div>
                  <p className="id__dur-desc">
                    A deeper, skill-enhancing program designed for students with prior exposure. It focuses
                    on complex system building, integration concepts, and advanced hands-on applications
                    with industry-level project experience.
                  </p>
                  <button className="id__dur-btn" onClick={() => setShowApply('week2')}>View Details & Apply →</button>
                </div>

                {/* 1 Month */}
                <div className="id__dur-card id__dur-card--full">
                  <div className="id__dur-header">
                    <div>
                      <h4 className="id__dur-weeks">1 Month</h4>
                      <p className="id__dur-track">Full Programme Track</p>
                    </div>
                    <span className="id__dur-badge">All Domains</span>
                  </div>
                  <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginBottom: '10px', padding: '0 16px' }}>
                    <div>
                      <p style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', marginBottom: '6px' }}>Foundation Courses</p>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {['Embedded Systems', 'IoT', 'Robotics'].map((c, i) => (
                          <span key={i} style={{ background: '#e8f5e9', color: '#2e7d32', borderRadius: '20px', padding: '3px 10px', fontSize: '11px', fontWeight: 600 }}>✓ {c}</span>
                        ))}
                      </div>
                    </div>
                    <div>
                      <p style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', marginBottom: '6px' }}>Advanced Courses</p>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {['AI with RPi', 'Mechatronics', 'Drone Technology', '3D Printing', 'Advanced Robotics', 'IIoT & AIoT', 'STM32 RMS', 'Prototype Dev.'].map((c, i) => (
                          <span key={i} style={{ background: '#e3f2fd', color: '#1565c0', borderRadius: '20px', padding: '3px 10px', fontSize: '11px', fontWeight: 600 }}>✓ {c}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="id__dur-desc">
                    A complete, immersive training program covering all levels of learning from fundamentals
                    to advanced implementation. Students work on end-to-end system development, culminating
                    in a fully functional real-world prototype with documentation and certification.
                  </p>
                  <button className="id__dur-btn" onClick={() => setShowApply('month1')}>View Details & Apply →</button>
                </div>

              </div>
            </div>
          )}
        </div>

      </div>

      {showApply && (
        <InternshipApply track={showApply} onClose={() => setShowApply(null)} />
      )}
      {showProfessional && (
        <ProfessionalInternship onClose={() => setShowProfessional(false)} />
      )}
    </div>
  );
}

export default InternshipDetail;
